<div class="row" *ngIf="!isLoading; else outLoading">
  <div class="col-md-12">
    <!--  -->
    <div class="table-responsive" *ngIf="leavesData.length">
      <div class="text-center-font">Leave Approvals</div>
      <hr style="background: red" />
      <div class="float-left">
        <button
          class="btn btn-sm btn-primary mb-1"
          (click)="bulkApproval()"
          type="button"
          [disabled]="loadingBulkApprove"
        >
          <span
            *ngIf="loadingBulkApprove"
            class="spinner-border spinner-border-sm mr-1"
          ></span
          >Bulk Approval
        </button>
      </div>
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>
              <label class="form-check-label">
                Select all<br />
                <input
                  type="checkbox"
                  (change)="checkUncheckAllLeave($event)"
                />
              </label>
            </th>
            <th>Leave Id</th>
            <th>Emp Name</th>
            <th>Applied Date</th>

            <th>Days</th>
            <th>Leave Type</th>
            <th>Action By / Date</th>
            <th>On Behalf?</th>
            <th>Reason</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody
          *ngFor="
            let data of leavesData
              | paginate
                : {
                    id: 'leavepage',
                    itemsPerPage: pageSize,
                    currentPage: page,
                    totalItems: count
                  };
            let i = index
          "
        >
          <tr>
            <td>
              {{ i + 1 }}. &nbsp;&nbsp;&nbsp;
              <input
                *ngIf="data.pending > 0"
                type="checkbox"
                [(ngModel)]="data.isSelected"
              />
            </td>
            <td>
              #{{ data.lv_id }}<br />
              <a *ngIf="data.doc_attachment" href="{{ data.doc_attachment }}"
                >View Document</a
              >
            </td>
            <td>{{ data.username }}</td>
            <td>
              {{ data.applied_date | date : "dd/MM/yyyy H:mm:ss" }}
            </td>

            <td>
              <mat-chip-list aria-label="leave days">
                <mat-chip
                  *ngFor="let item of data.trans"
                  [color]="item.color"
                  [selected]="item.color != '' ? true : false"
                  >{{ item.lv_date | date : "dd/MM/yyyy" }}</mat-chip
                >
              </mat-chip-list>
            </td>

            <td>
              {{ data.lv_desc }}<br /><br />
              <span
                *ngIf="data.is_exceptional"
                style="
                  padding: 7px;
                  background: #f62d51;
                  color: white;
                  white-space: nowrap;
                "
              >
                Exceptional Request
              </span>
            </td>
            <td>
              {{ data.actionBy }}-{{ data.actionByName }}
              {{ data.actionByLname }}
              <br />
              <span *ngIf="data.actionBy">{{
                data.actionByUpdate | date : "dd/MM/yyyy  H:mm:ss"
              }}</span>
            </td>
            <td>
              {{ data.is_on_behalf == 1 ? "YES" : "NO" }} <br />{{
                data.on_behalf_created_by
              }}
            </td>
            <td>{{ data.reason }}</td>
            <td>
              <section *ngIf="data.is_rejectable; else noRejectable">
                <div
                  class="btn-group btn-group-sm d-block"
                  *ngIf="data.pending > 0; else approved"
                >
                  <button
                    type="button"
                    class="btn btn-sm btn-success"
                    (click)="approveRej(data, 1)"
                  >
                    <i class="fa fa-user-plus" aria-hidden="true"></i>
                    Approve
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    (click)="approveRej(data, 2)"
                  >
                    <i class="fa fa-user-times" aria-hidden="true"></i>
                    Reject
                  </button>
                </div>
                <ng-template #approved>
                  <section *ngIf="data.approved > 0; else noRejectable">
                    <button
                      type="button"
                      class="btn btn-sm btn-danger"
                      (click)="approveRej(data, 3)"
                    >
                      <i class="fa fa-user-times" aria-hidden="true"></i>
                      Reject
                    </button>
                  </section>
                </ng-template>
              </section>
              <ng-template #noRejectable>
                {{
                  data.trans.length === data.pending
                    ? "Pending"
                    : data.trans.length == data.approved
                    ? "Approved"
                    : data.pending > 0
                    ? "Pending"
                    : data.approved > 0
                    ? "Approved"
                    : "Rejected"
                }}
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--  -->
    <div class="table-responsive" *ngIf="attRegulariseDataCount > 0">
      <div class="text-center-font">Attendance Regularization Approvals</div>
      <hr style="background: red" />
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>S.No.</th>
            <th>Cost Center</th>
            <th>Date</th>
            <th>Emp Name</th>
            <th>Requested Date</th>
            <th>Attendance</th>
            <th>In Time</th>
            <th>Out Time</th>
            <th>Total Hrs</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of attRegulariseData; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.cc_desc }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.username }} {{ item.name }} {{ item.lname }}</td>
            <td>{{ item.requested_on }}</td>
            <td>{{ item.code }}</td>
            <td>{{ item.in_time }}</td>
            <td>{{ item.out_time }}</td>
            <td>{{ item.ot_hrs }}</td>
            <td>
              <div class="btn-group btn-group-sm d-block">
                <button
                  type="button"
                  class="btn btn-sm btn-success"
                  (click)="approveRejRegularise(item, 1)"
                >
                  <i class="fa fa-check" aria-hidden="true"></i> Approve
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-danger"
                  (click)="approveRejRegularise(item, 0)"
                >
                  <i class="fa fa-user-times" aria-hidden="true"></i>
                  Reject
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--  -->
    <div class="table-responsive" *ngIf="mrfApprovalsCount != 0">
      <div class="text-center-font">MRF Approvals</div>
      <hr style="background: red" />

      <div class="mt-10 mb-1 text-left">
        <button
          type="button"
          (click)="submitBulkMrfApprove('2')"
          class="btn btn-primary btn-sm mr-10"
        >
          Approve
        </button>
        <button
          type="button"
          (click)="submitBulkMrfApprove('7')"
          class="btn btn-danger btn-sm mr-10"
        >
          Reject
        </button>
      </div>
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>
              <label class="form-check-label">
                Select all<br />
                <input type="checkbox" (change)="checkUncheckAllMRf($event)" />
              </label>
            </th>
            <th>MRF Id</th>
            <th>Cost Center</th>
            <th>Hiring Type</th>
            <th>Designation</th>
            <th>Status</th>
            <th>Created ON</th>
            <th>Created By</th>
            <th>Require By Date</th>
            <th>Attachment</th>
            <th>Approve</th>
            <th>Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let appr of mrfApprovals">
            <td>
              <input type="checkbox" [(ngModel)]="appr.isSelected" />
            </td>
            <td>
              {{ appr.mrf_code }}
              <a
                [routerLink]="['/talent/mrf-details', appr.mrf_enc_id]"
                target="_blank"
                ><i class="fa fa-eye"></i
              ></a>
            </td>
            <td>{{ appr.cc_desc }}</td>
            <td>
              {{ appr.mrf_type }} <br />{{ appr.emp_cate }}<br />
              {{ appr.skill_type }}
            </td>
            <td>
              {{ appr.desig_desc }}
              <br />
              <span *ngIf="appr.level != 0">
                <b> Level :</b> {{ appr.level_name }}
              </span>
            </td>
            <td>{{ appr.status_desc }}</td>
            <td>{{ appr.created_at }}</td>
            <td>{{ appr.name }}</td>
            <td>{{ appr.reqd_by }}</td>
            <td class="text-center">
              <a
                [href]="appr.attachment"
                *ngIf="appr.attachment != ''"
                target="_blank"
              >
                <i class="fa fa-paperclip"></i>
              </a>
            </td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="
                  submitMrfApprove(
                    appr.rel_id,
                    appr.approve_id,
                    appr.rel_group_id,
                    appr.txn_id
                  )
                "
              >
                Approve
              </button>
            </td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="
                  submitMrfApprove(
                    appr.rel_id,
                    appr.reject_id,
                    appr.rel_group_id,
                    appr.txn_id
                  )
                "
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- naps -->
    <div class="table-responsive" *ngIf="napsMrfApprovalsCount != 0">
      <div class="text-center-font">NAPS MRF Approvals</div>
      <hr style="background: red" />
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>MRF Id</th>
            <th>Cost Center</th>
            <th>Designation</th>
            <th>Status</th>
            <th>Created ON</th>
            <th>Created By</th>
            <th>Require By Date</th>
            <th>Attachment</th>
            <th>Approve</th>
            <th>Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let appr of napsMrfApprovals">
            <td>
              {{ appr.mrf_code }}
              <a
                [routerLink]="['/talent/naps-mrf-details', appr.mrf_enc_id]"
                target="_blank"
                ><i class="fa fa-eye"></i
              ></a>
            </td>
            <td>{{ appr.cc_desc }}</td>
            <td>{{ appr.desig_desc }}</td>
            <td>{{ appr.status_desc }}</td>
            <td>{{ appr.created_at }}</td>
            <td>{{ appr.name }}</td>
            <td>{{ appr.reqd_by }}</td>
            <td class="text-center">
              <a
                [href]="appr.attachment"
                *ngIf="appr.attachment != ''"
                target="_blank"
              >
                <i class="fa fa-paperclip"></i>
              </a>
            </td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="
                  submitNapsMrfApprove(
                    appr.rel_id,
                    appr.approve_id,
                    appr.rel_group_id,
                    appr.txn_id,
                    appr.created_by
                  )
                "
              >
                Approve
              </button>
            </td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="
                  submitNapsMrfApprove(
                    appr.rel_id,
                    appr.approve_id,
                    appr.rel_group_id,
                    appr.txn_id,
                    appr.created_by
                  )
                "
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- naps-->

    <div class="table-responsive" *ngIf="transferApprovalsCount != 0">
      <div class="text-center-font">Transfer Approvals</div>
      <hr style="background: red" />
      <div class="mt-10 mb-1 text-left">
        <button
          type="button"
          (click)="submitBulkTransferApprove('2')"
          class="btn btn-primary btn-sm mr-10"
        >
          Approve
        </button>
        <button
          type="button"
          (click)="submitBulkTransferApprove('7')"
          class="btn btn-danger btn-sm mr-10"
        >
          Reject
        </button>
      </div>
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>
              <label class="form-check-label">
                Select all<br />
                <input
                  type="checkbox"
                  (change)="checkUncheckAllTransfer($event)"
                />
              </label>
            </th>
            <th>MRF Id / Transfer Type</th>
            <th>Employee Name</th>
            <th>IN Cost Center</th>
            <th>Transfer IN Date</th>
            <th>Site IN Zone / PF Type</th>
            <th>Out Cost Center</th>
            <th>Transfer Out Date</th>
            <th>Site Out Zone / PF Type</th>
            <th>Status</th>
            <th>Created Details</th>
            <th>Approve / Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let appr of transferApprovals">
            <td>
              <input type="checkbox" [(ngModel)]="appr.isSelected" />
            </td>
            <td>
              {{ appr.mrf_code }}
              <a
                [routerLink]="['/talent/mrf-transfer-details', appr.mrf_enc_id]"
                target="_blank"
                ><i class="fa fa-eye"></i
              ></a>
              <br />{{ appr.trnsfer_type }} <br />
              <a
                [href]="appr.attachment"
                *ngIf="appr.attachment != ''"
                target="_blank"
              >
                <i class="fa fa-paperclip"></i>
              </a>
            </td>
            <td>{{ appr.emp_name }}</td>
            <td>{{ appr.cc_desc }}</td>
            <td>{{ appr.reqd_by }}</td>
            <td>
              {{ appr.new_sch_emp }} <br />
              {{ appr.new_zone }} <br />
              {{ appr.new_pf_type }}
            </td>
            <td>{{ appr.old_cc_desc }}</td>
            <td>{{ appr.trans_out_date }}</td>
            <td>
              {{ appr.old_sch_emp }} <br />
              {{ appr.old_zone }} <br />
              {{ appr.old_pf_type }}
            </td>
            <td>{{ appr.status_desc }}</td>
            <td>
              {{ appr.created_name }} <br />
              {{ appr.created_at }}
            </td>
            <td>
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="
                  submitTransferApprove(
                    appr.rel_id,
                    appr.approve_id,
                    appr.rel_group_id,
                    appr.txn_id,
                    appr.rel_level
                  )
                "
              >
                Approve
              </button>
              &nbsp;
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="
                  submitTransferApprove(
                    appr.rel_id,
                    appr.reject_id,
                    appr.rel_group_id,
                    appr.txn_id,
                    appr.rel_level
                  )
                "
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-responsive" *ngIf="exitApprovalsCount != 0">
      <div class="text-center-font">Exit Approvals</div>
      <hr style="background: red" />
      <div class="mt-10 mb-1 text-left">
        <button
          type="button"
          (click)="submitBulkExitApprove('0')"
          class="btn btn-danger btn-sm mr-10"
        >
          Reject
        </button>
        <button
          type="button"
          (click)="submitBulkExitApprove('1')"
          class="btn btn-primary btn-sm mr-10"
        >
          Approve
        </button>
      </div>
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>
              <label class="form-check-label">
                <input type="checkbox" (change)="checkUncheckAllEXIT($event)" />
                &nbsp;&nbsp;Select all
              </label>
            </th>
            <th>Sr no</th>
            <th>Cost Center</th>
            <th>Employee</th>
            <th>Resignation Date</th>
            <th>Category</th>
            <th>Reason</th>
            <th>Last Working Date</th>
            <th>On Behalf</th>
            <th>Is Blacklisted ?</th>
            <th>Reportiees new reporting manager</th>
            <th>Attachment</th>
            <th>Retention mannager action</th>
            <th>Action</th>
            <th>Update</th>
            <!-- <th>Approve</th>
                                            <th>Reject</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of exitApprovals; let i = index">
            <td>
              <span *ngIf="data.is_rm_take_action == true">
                <input type="checkbox" [(ngModel)]="data.isSelected" />
              </span>
            </td>
            <td>{{ i + 1 }}</td>
            <td>{{ data.cost_center }}</td>
            <td>{{ data.emp_name }}</td>
            <td>{{ data.exit_init_date }}</td>
            <td>{{ data.vltry_name }}</td>
            <td>{{ data.reason_name }}</td>
            <td>{{ data.exit_nego_date }}</td>
            <td>
              <span *ngIf="data.is_exit_on_behalf"
                >Yes By {{ data.obh_emp_name }}</span
              >
              <span *ngIf="!data.is_exit_on_behalf">No</span>
            </td>
            <td>
              <span *ngIf="data.is_blacklist">Yes</span>
              <span *ngIf="!data.is_blacklist">No</span>
            </td>
            <td>{{ data.nrm_emp_name }}</td>
            <td class="text-center">
              <a [href]="data.img" *ngIf="data.img != ''" target="_blank">
                <i class="fa fa-paperclip"></i>
              </a>
            </td>
            <!-- <td class="text-center"><button class="btn btn-primary btn-sm btn-sm-custom" (click)="submitExitApprove(data.rel_id,data.exit_id, data.approve_id) ">Approve</button></td> -->
            <td class="text-center">
              <span *ngIf="data.is_ret_aprve==0" class="text-primary">Pending</span>
              <span *ngIf="data.is_ret_aprve==1" class="text-success">Approved</span>
              <span *ngIf="data.is_ret_aprve==2" class="text-danger">Rejected</span>
              <span *ngIf="data.is_ret_aprve==3" class="text-primary">Auto Approved</span>
            </td>
            <td>
              <span *ngIf="data.is_rm_take_action == true">
                <button
                  type="button"
                  class="btn btn-primary btn-sm btn-sm-custom"
                  (click)="
                    submitExitApprove(
                      data.rel_id,
                      data.exit_id,
                      data.approve_id,
                      1,
                      data.emp_user_id,
                      data.rel_user_id,
                      data.rel_level,
                      data.reporties_count,
                      data.rpls_rm_id,
                      data.emp_name
                    )
                  "
                >
                  Approve
                </button>
                <br />
                <button
                  type="button"
                  class="btn btn-danger btn-sm btn-sm-custom m-t-5"
                  (click)="
                    submitExitApprove(
                      data.rel_id,
                      data.exit_id,
                      data.reject_id,
                      0,
                      data.emp_user_id,
                      data.rel_user_id,
                      data.rel_level,
                      data.reporties_count,
                      data.rpls_rm_id,
                      data.emp_name
                    )
                  "
                >
                  Reject
                </button>
              </span>
              <span *ngIf="data.is_rm_take_action == false">
                <button class="btn btn-sm btn-warning">Pending with Retention Manager</button>
              </span>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="openExitupdateModal('#exit_update_modal', data, 1)"
              >
                <i class="fa fa-pencil-square-o"></i> Edit
              </button>
              <br />
              <button
                type="button"
                class="btn btn-warning btn-sm btn-sm-custom m-t-5"
                (click)="openExitupdateModal('#exit_date_modal', data, 2)"
              >
                Change Exit Date
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--  -->
    <div class="table-responsive" *ngIf="expensesCount != 0">
      <div class="text-center-font">Expense Approvals</div>
      <hr style="background: red" />
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>Sr no / Status</th>
            <th>Expense Id / Claim No.</th>
            <th>Employee</th>
            <th>Cost Center</th>
            <th>Expense Amount</th>
            <th>Vendor Name / Invoice</th>
            <th>Expense Category</th>
            <th>Expense Date / Entry Date</th>
            <th>Empoyee Remark</th>
            <th>FN Remark</th>
            <th>Travel Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of expenseApprovals; let i = index">
            <td>
              {{ i + 1 }} . &nbsp; {{ item.status_desc }}
              <br />
              <button
                class="btn btn-sm btn-danger text-white"
                (click)="resolveExpense(item, '#take_action_expense')"
              >
                Action
              </button>
            </td>
            <td>{{ item.expns_id }} / {{ item.claim_id }}</td>
            <td>
              {{ item.emp_name }}
              <br />
              <button style="cursor: default" class="btn-xs btn-warning">
                {{ item.category }} - {{ item.desig_desc }}
              </button>
            </td>
            <td>{{ item.expns_cc_desc }}</td>
            <td>{{ item.expns_amt }} <br /></td>
            <td>
              {{ item.vendor_desc }} <br />
              {{ item.invoice_no }} &nbsp; <br /><span
                *ngIf="item.attachment1 == '' && item.attachment2 == ''"
              >
                <button style="cursor: default" class="btn-xs btn-warning">
                  No Bill
                </button>
              </span>
              <a
                *ngIf="item.attachment1 != ''"
                href="{{ item.attachment1 }} "
                class="mt-5"
                download=" "
                target="_blank"
                ><button style="cursor: default" class="btn-danger">
                  <i class="fa fa-paperclip"></i> File
                </button>
              </a>
              &nbsp;
              <a
                *ngIf="item.attachment2 != ''"
                href="{{ item.attachment2 }} "
                class="mt-5"
                download=" "
                target="_blank"
                ><button style="cursor: default" class="btn-danger">
                  <i class="fa fa-paperclip"></i> File 2
                </button>
              </a>
            </td>
            <td>{{ item.cat_desc }}</td>
            <td>{{ item.expns_date }} / {{ item.entry_date }}</td>
            <td>{{ item.remarks }}</td>
            <td>{{ item.finance_remark }}</td>
            <td>
              {{ item.transport_mode }} <br />
              {{ item.travel_from }} {{ item.travel_to }} <br />
              {{ item.travel_reason }} <br />
              {{ item.reason_remark }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--  -->
    <div class="table-responsive" *ngIf="smarttripCount != 0">
      <div class="text-center-font">SmartTrip Approvals</div>
      <hr style="background: red" />
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>Sr no / Status</th>
            <th>Expense Id / Claim No.</th>
            <th>Employee</th>
            <th>Cost Center</th>
            <th>Expense Category / Amount</th>
            <th>Travel Details</th>
            <th>Travel Date</th>
            <th>Start Time / End Time</th>
            <th>User KMS / Google KMS</th>
            <th>Mode</th>
            <th>FN Remark</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of smarttripApprovals; let i = index">
            <td>
              {{ i + 1 }} . &nbsp; {{ item.status_desc }} <br />
              <button
                class="btn btn-sm btn-danger text-white"
                (click)="resolveExpense(item, '#take_action_expense')"
              >
                Action
              </button>
            </td>
            <td>{{ item.expns_id }} / {{ item.claim_id }}</td>
            <td>
              {{ item.emp_name }} <br />
              {{ item.category }} <br />{{ item.desig_desc }}
            </td>
            <td>{{ item.expns_cc_desc }}</td>
            <td>
              {{ item.cat_desc }} <br />
              {{ item.expns_amt }}
            </td>
            <td>{{ item.trip_title_desc }}</td>
            <td>{{ item.start_date }}</td>
            <td>{{ item.start_time }} / {{ item.end_time }}</td>
            <td>
              {{ item.user_km_dist }} / {{ item.map_km_dist }} &nbsp;
              <a
                *ngIf="item.map_img != ''"
                href="{{ item.map_img }} "
                class="mt-5"
                target="_blank"
                ><button style="cursor: default" class="btn-danger">
                  <i class="fa fa-paperclip"></i> File
                </button>
              </a>
            </td>
            <td>{{ item.trip_mode_desc }}</td>
            <td>{{ item.finance_remark }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--  -->
    <div class="table-responsive" *ngIf="awardApprovalsCount != 0">
      <div class="text-center-font">Awards Approvals</div>
      <hr style="background: red" />
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>#</th>
            <th>Award Id</th>
            <th>Cost Center</th>
            <th>Employee</th>
            <th>Category</th>
            <th>Award Name</th>
            <th>Date</th>
            <th>Remark</th>
            <th>Nominated By</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of awardApprovals; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ data.awrd_id }}</td>
            <td>{{ data.emp_cc_name }}</td>
            <td>{{ data.emp_username }}-{{ data.emp_name }}</td>
            <td>{{ data.cat_desc }}</td>
            <td>{{ data.subcat_desc }}</td>
            <!-- <td>{{data.datetime | date: 'dd/MM/yyyy H:mm:ss a'}}</td> -->
            <td>{{ data.datetime }}</td>
            <td>{{ data.remark }}</td>
            <td>{{ data.nominated_by }}-{{ data.nominated_name }}</td>
            <td>
              <button
                class="btn btn-sm btn-danger text-white"
                (click)="resolveAward(data, '#take_action')"
              >
                Action
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--  -->
    <div class="table-responsive" *ngIf="idCardApprovalsCount != 0">
      <div class="text-center-font">ID Card Approvals</div>
      <hr style="background: red" />
      <div class="mt-10 mb-1 text-left">
        <button
          type="button"
          (click)="submitBulkIDCardApprove('1')"
          class="btn btn-primary btn-sm mr-10"
        >
          Approve
        </button>
        <button
          type="button"
          (click)="submitBulkIDCardApprove('0')"
          class="btn btn-danger btn-sm mr-10"
        >
          Reject
        </button>
      </div>
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>
              <label class="form-check-label"
                >Select all<br />
                <input
                  type="checkbox"
                  (change)="checkUncheckAllIDCard($event)"
                />
              </label>
            </th>

            <th>Cost Center</th>
            <th>Employee</th>
            <th>Image</th>
            <th>Mobile</th>
            <th>Requested On</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Approve</th>
            <th>Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of idCardApprovals; let i = index">
            <td>
              <input type="checkbox" [(ngModel)]="data.isSelected" />
            </td>
            <td>{{ data.cc_ext_id }} - {{ data.cc_desc }}</td>
            <td>
              {{ data.emp_username }}-{{ data.emp_name }}
              {{ data.emp_lname }}
            </td>
            <td *ngIf="data.req_doc_id != ''">
              <img [src]="data.req_doc_id" height="100px" />
            </td>
            <td *ngIf="data.req_doc_id == ''"></td>
            <td>{{ data.mobile }}</td>
            <td>{{ data.req_date }}</td>
            <td>{{ data.rel_status }}</td>
            <td>
              {{ data.cr_username }}-{{ data.cr_name }}
              {{ data.cr_lname }}
            </td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="
                  submitIDCardApprove(data.rel_id, data.req_id, data.approve_id)
                "
              >
                Approve
              </button>
            </td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="
                  submitIDCardApprove(data.rel_id, data.req_id, data.reject_id)
                "
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--  -->

    <!--Visiting Card -->
    <div class="table-responsive" *ngIf="epaApprovalsCount != 0">
      <div class="text-center-font">Aspire Year End Task Approvals</div>
      <hr style="background: red" />
      <div class="mt-10 mb-1 text-left">
        <button
          type="button"
          (click)="submitEpaBulkApproval('1')"
          class="btn btn-primary btn-sm mr-10"
        >
          Approve
        </button>
        <button
          type="button"
          (click)="submitEpaBulkApproval('0')"
          class="btn btn-danger btn-sm mr-10"
        >
          Reject
        </button>
      </div>
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>
              <label class="form-check-label"
                >Select all<br />
                <input
                  type="checkbox"
                  (change)="checkUncheckAllVisitCard($event)"
                  [ngModelOptions]="{ standalone: true }"
                />
              </label>
            </th>
            <th>Cost Center</th>
            <th>Employee</th>
            <th>Manager</th>
            <th>Overall Rating</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Approve</th>
            <th>Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of epaApprovals; let i = index">
            <td>
              <input type="checkbox" [(ngModel)]="data.isSelected" />
            </td>
            <td>{{ data.cc_ext_id }} - {{ data.cc_desc }}</td>
            <td>{{ data.EmpName }}</td>
            <td>{{ data.MngrName }}</td>
            <td>{{ data.rating_desc }}</td>
            <td>{{ data.rel_status }}</td>
            <td>{{ data.CrEmpName }}</td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="submitEpaApproval(data.rel_id, '1')"
              >
                Aproved
              </button>
            </td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="submitEpaApproval(data.rel_id, '0')"
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--  -->

    <div class="table-responsive" *ngIf="pettyCashApprovalCount != 0">
      <div class="text-center-font">Petty Cash Request Approvals</div>
      <hr style="background: red" />
      <!-- <div class="mt-10 ">
                                <button type="button" class="btn btn-primary btn-sm mr-10 " (click)="submitPettyCashBulkApproval( '1') "> Bulk Approve</button>
                            </div> -->
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>
              <label class="form-check-label"
                >Request ID<br />
                <!-- <input type="checkbox" (change)="checkUncheckAllPettyCash($event) "> -->
              </label>
            </th>
            <!-- <th>Request ID</th> -->
            <th>Requested By</th>
            <th>Cost Center</th>
            <th>Requested Amount</th>
            <th>Eligiblity Amount</th>
            <th>Site Balance</th>
            <th>Requested Date</th>
            <th>Requestor Remark</th>
            <th>Attachments</th>
            <th>Approve</th>
            <th>Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of pettyCashApprovals; let i = index">
            <td>
              <!-- <input type="checkbox" [(ngModel)]="data.isSelected">  -->
              <br />
              # {{ data.rqst_id }}
            </td>
            <td>{{ data.requestorName }}</td>
            <td>{{ data.siteName }}</td>
            <td>
              <i class="fa fa-inr" aria-hidden="true"></i>
              {{ data.req_amount }} <br />
              <span class="text-danger" *ngIf="data.is_exception == 1">
                <b> * Exception Case</b></span
              >
            </td>
            <td>
              <i class="fa fa-inr" aria-hidden="true"></i>
              {{ data.elg_amount }}
            </td>
            <td>
              <i class="fa fa-inr" aria-hidden="true"></i>
              {{ data.balance }}
            </td>
            <td>{{ data.rqst_date | date : "dd/MM/yyyy" }}</td>
            <td>{{ data.rqst_remark }}</td>
            <td>
              <a
                [href]="data.attachment1"
                *ngIf="data.rqst_attachment1 != ''"
                target="_blank"
                ><button class="btn-danger">
                  <i class="fa fa-paperclip"></i> Doc 1
                </button></a
              >
              <br />&nbsp; <br />
              <a
                [href]="data.attachment2"
                *ngIf="data.rqst_attachment2 != ''"
                target="_blank"
                ><button class="btn-danger">
                  <i class="fa fa-paperclip"></i> Doc 2
                </button></a
              >
            </td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="submitPettyCashApproval(data, '1')"
              >
                Approve
              </button>
            </td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="submitPettyCashApproval(data, '0')"
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--  -->

    <div class="table-responsive" *ngIf="pettyCashExpenseApprovalCount != 0">
      <div class="text-center-font">Petty Cash Expense Approvals</div>
      <hr style="background: red" />
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>Txn ID</th>
            <th>Submitted By</th>
            <th>Cost Center</th>
            <th>Site Balance</th>
            <th>Amount pending in approvals</th>
            <th>Invoice</th>
            <th>Vendor</th>
            <th>GL Code</th>
            <th>Is Billable ?</th>
            <th>Submitted Date</th>
            <th>PO No</th>
            <th>Approve</th>
            <th>Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of pettyCashExpenseApprovals; let i = index">
            <td>{{ data.txn_id }}</td>
            <td>{{ data.requestorName }}</td>
            <td>{{ data.siteName }}</td>
            <td>
              <i class="fa fa-inr" aria-hidden="true"></i>
              {{ data.balance }}
            </td>
            <td>
              <i class="fa fa-inr" aria-hidden="true"></i>
              {{ data.pendingAmntAppr }}
            </td>
            <td>
              <b> No:</b> {{ data.vnd_invc_id }} <br />
              <b> Date:</b> {{ data.invc_date | date : "d-LLL-y" }}
              <br />
              <b> Amt: </b
              ><i class="fa fa-inr" aria-hidden="true" *ngIf="data.invc_amt"></i
              >{{ data.invc_amt }} <br /><a
                [href]="data.attachment1"
                *ngIf="data.invc_attachment1 != ''"
                target="_blank"
                ><button class="btn-danger">
                  <i class="fa fa-paperclip"></i> File
                </button>
              </a>
              &nbsp;
              <a
                [href]="data.attachment2"
                *ngIf="data.invc_spprt_attachment1 != ''"
                target="_blank"
                ><button class="btn-success">
                  <i class="fa fa-paperclip"></i> Sup Doc 1
                </button></a
              >&nbsp; &nbsp;
              <a
                [href]="data.attachment3"
                *ngIf="data.invc_spprt_attachment2 != ''"
                target="_blank"
                ><button class="btn-success">
                  <i class="fa fa-paperclip"></i> Sup Doc 2
                </button></a
              >
            </td>
            <td>
              {{ data.vendor_org }} <br />
              <b> GST No: </b> {{ data.vendor_gst }}
            </td>
            <td>
              <span *ngIf="data.gl_code">
                <b> Code:</b> {{ data.gl_code }}
              </span>
              <span *ngIf="data.gl_desc"
                ><br />
                <b> Desc:</b> {{ data.gl_desc }}
              </span>
            </td>
            <td>{{ data.isBillable }}</td>

            <td>{{ data.date_of_submit }}</td>
            <td>{{ data.po_id }}</td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="submitPettyCashExpenseApproval(data.rel_id, '1')"
              >
                Approve
              </button>
            </td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="submitPettyCashExpenseApproval(data.rel_id, '0')"
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--  -->
    <div class="table-responsive" *ngIf="workPlaceApprovalsCount != 0">
      <div class="text-center-font">WorkPlace Approvals</div>
      <hr style="background: red" />
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>S No.</th>
            <th>Cost Center</th>
            <th>Employee</th>
            <th>Visiting Office</th>
            <th>Visiting Dates and Time</th>
            <th>Date of Visiting Office</th>
            <th>End Date</th>
            <th>HOD's Approval Email</th>
            <th>Vaccination Certificate</th>
            <th>Approve</th>
            <th>Reject</th>
          </tr>
        </thead>
        <tbody *ngFor="let data of workPlaceApprovals; let i = index">
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ data.siteName }}</td>
            <td>{{ data.emp_name }}</td>
            <td>{{ data.vst_office_name }}</td>
            <td>
              <!-- {{data.datesList}} -->
              <button
                type="button"
                *ngFor="let li of data.datesList"
                class="btn btn-primary btn-sm mt-5"
              >
                {{ li }}
              </button>
            </td>

            <td>{{ data.start_date_of_visit }}</td>
            <td>{{ data.end_date_of_visit }}</td>
            <td class="text-center">
              <a
                [href]="data.hod_attach"
                *ngIf="data.hod_attach != ''"
                target="_blank"
              >
                <i class="fa fa-paperclip"></i>
              </a>
            </td>
            <td class="text-center">
              <a
                [href]="data.vaccin_attach"
                *ngIf="data.vaccin_attach != ''"
                target="_blank"
              >
                <i class="fa fa-paperclip"></i>
              </a>
            </td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="submitWrkplaceApproval(data, '1')"
              >
                Approve
              </button>
            </td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="submitWrkplaceApproval(data, '0')"
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- visiting card approvals -->

    <div class="table-responsive" *ngIf="visitingCardApprovalsCount != 0">
      <div class="text-center-font">Visiting Card Approvals</div>
      <hr style="background: red" />
      <div class="mt-10 mb-1 text-left">
        <button
          type="button"
          (click)="submitBulkVisitingCardApprove('1')"
          class="btn btn-primary btn-sm mr-10"
        >
          Approve
        </button>
        <button
          type="button"
          (click)="submitBulkVisitingCardApprove('0')"
          class="btn btn-danger btn-sm mr-10"
        >
          Reject
        </button>
      </div>
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>
              <label class="form-check-label"
                >Select all<br />
                <input
                  type="checkbox"
                  (change)="checkUncheckAllVisitCard($event)"
                  [ngModelOptions]="{ standalone: true }"
                />
              </label>
            </th>
            <th>Cost Center</th>
            <th>Employee</th>
            <th>Mobile</th>
            <th>Requested On</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Approve</th>
            <th>Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of visitingCardApprovals; let i = index">
            <td>
              <input type="checkbox" [(ngModel)]="data.isSelected" />
            </td>
            <td>{{ data.cc_ext_id }} - {{ data.cc_desc }}</td>
            <td>
              {{ data.emp_username }}-{{ data.emp_name }}
              {{ data.emp_lname }}
            </td>

            <td>{{ data.mobile }}</td>
            <td>{{ data.req_date }}</td>
            <td>{{ data.rel_status }}</td>
            <td>
              {{ data.cr_username }}-{{ data.cr_name }}
              {{ data.cr_lname }}
            </td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="
                  submitVisitingCardApprove(
                    data.rel_id,
                    data.req_id,
                    data.approve_id
                  )
                "
              >
                Approve
              </button>
            </td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="
                  submitVisitingCardApprove(
                    data.rel_id,
                    data.req_id,
                    data.reject_id
                  )
                "
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ongc Approval -->

    <div class="table-responsive" *ngIf="ongcpassCount != 0">
      <div class="text-center-font">ONGC Pass Approvals</div>
      <hr style="background: red" />
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>Sr.No</th>
            <th>Cost Center</th>
            <th>Employee</th>
            <th>Status</th>
            <th>Request On</th>
            <th>Created By</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dat of ongcApprovals; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ dat.pl_ext_id }} {{ dat.pl_name }}</td>
            <td>{{ dat.empName }}</td>
            <td>{{ dat.rel_status }}</td>
            <td>{{ dat.created_at }}</td>

            <td class="text-center">
              <button
                class="btn btn-primary btn-sm btn-sm-custom"
                (click)="submitOngcPassApprove(dat.id, dat.rel_id, 2)"
              >
                Approve
              </button>
            </td>
            <td class="text-center">
              &nbsp;&nbsp;
              <button
                class="btn btn-danger btn-sm btn-sm-custom"
                (click)="submitOngcPassApprove(dat.id, dat.rel_id, 0)"
              >
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Buddy Pending Employees List  -->

    <div class="table-responsive" *ngIf="pendingEmpBuddyCount != 0">
      <div class="text-center-font">
        {{ pendingEmpBuddyCount }} Employees With No Buddy / Training Champion
        Mapping
      </div>
      <hr style="background: red" />

      <button class="btn btn-primary mb-2" [routerLink]="['/l&d/my-buddy']">
        Click here to download and review the pending list
      </button>

      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>Sr.No</th>
            <th>Site Name</th>
            <th>Employee</th>
            <th>Date Of Joining</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dat of buddyPendingEmployeeList; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ dat.cc_ext_id }} {{ dat.site_name }}</td>
            <td>{{ dat.username }} - {{ dat.emp_name }}</td>
            <td>{{ dat.doj }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--  *ngIf="committeeDataCount > 0" -->
    <div class="table-responsive" *ngIf="committeeDataCount !=0 ">
      <div class="text-center-font">Idea Committee Approvals</div>
      <hr style="background: red" />
      <table class="table table-striped mb-0">
        <thead>
          <tr class="bg-primary text-white">
            <th>S.No.</th>
            <th>Site Name</th>
            <th>Category</th>
            <th>Sub Category</th>
            <th>Idea Description</th>
            <th>Ideapreneur</th>
            <th>Remark</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of committeeData; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{item.site_name}}</td>
            <td>{{item.cat_desc}}</td>
            <td>{{item.subcat_desc}}</td>
            <td>{{item.idea_desc}}</td>
            <td>{{item.emp_name}}</td>
            <td>
              <textarea cols="8" rows="3" class="form-control" [(ngModel)]="commt_remark"> </textarea>
            </td>
            <td>
              <div class="btn-group btn-group-sm d-block">
                <button type="button" class="btn btn-sm btn-success" (click)="approvedIdea(item,2)">
                  <i class="fa fa-check" aria-hidden="true"></i> Approve </button>
                <button type="button" class="btn btn-sm btn-danger" (click)="approvedIdea(item, 3)">
                  <i class="fa fa-user-times" aria-hidden="true"></i> Reject</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


  </div>
</div>

<ng-template #outLoading>
  <div class="row">
    <div class="col-md-12 text-center">
      <h3>Loading Please wait ....</h3>
    </div>
  </div>
</ng-template>

<div
  id="take_action_expense"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 10600 !important ; background: #00000075"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <!-- <div class="modal-content"> -->
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">Take Action</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onCloseResolveExpense()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form
        [formGroup]="resolveFormExpense"
        (ngSubmit)="onSubmitResolveExpense()"
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="role_name">Action</label>
                <select
                  class="form-control"
                  (change)="takeAction($event)"
                  formControlName="is_approved"
                >
                  <option value="">Select</option>
                  <option *ngFor="let it of resolveAction" [value]="it.value">
                    {{ it.label }}
                  </option>
                </select>
                <!-- <select2
                  [data]="resolveAction"
                  
                  placeholder="Select Action"
                ></select2> -->
                <div
                  *ngIf="submitExp && expErrorMsg.is_approved.errors"
                  class="form-error"
                >
                  <div *ngIf="expErrorMsg.is_approved.errors.required">
                    Action is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="cmmntsaward">Comments</label>
                <textarea
                  type="text"
                  formControlName="remark"
                  class="form-control"
                  placeholder="Comments"
                ></textarea>
                <div
                  *ngIf="submitExp && expErrorMsg.remark.errors"
                  class="form-error"
                >
                  <div *ngIf="expErrorMsg.remark.errors.required">
                    Comments is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-primary btn-sm"
            [disabled]="loading"
          >
            <span
              *ngIf="loading"
              class="spinner-border spinner-border-sm mr-1"
            ></span>
            {{ btnName }}
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            (click)="onCloseResolveExpense()"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  id="petty_cash_appr_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 10600 !important"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <!-- <div class="modal-content"> -->
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          Approver Remark
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closepettyReqModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Remark </label>
              <textarea
                type="text"
                class="form-control"
                [(ngModel)]="pettyReqRejRemark"
                placeholder="Comments.. "
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="submit"
          class="btn btn-primary btn-sm"
          (click)="approveRejPettyRequest()"
        >
          <span *ngIf="pettyApprObj">
            {{ pettyApprObj.status == 1 ? "Approve" : "Reject" }}</span
          >
        </button>
        <button
          type="button"
          class="btn btn-danger btn-sm"
          data-dismiss="modal"
          (click)="closepettyReqModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  id="petty_cash_Expense_appr_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 10600 !important"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <!-- <div class="modal-content"> -->
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          Approver Remark
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closepettyExpnsModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Remark <span class="text-danger">*</span></label>
              <textarea
                type="text"
                class="form-control"
                [(ngModel)]="pettyExpnsRejRemark"
                placeholder="Comments.. "
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="submit"
          class="btn btn-primary btn-sm"
          (click)="rejectPettyExpense()"
        >
          <span *ngIf="pettyExpnsApprObj">
            {{ pettyExpnsApprObj.status == 1 ? "Approve" : "Reject" }}</span
          >
        </button>
        <button
          type="button"
          class="btn btn-danger btn-sm"
          data-dismiss="modal"
          (click)="closepettyExpnsModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<div
  id="take_action"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 10600 !important; background: #00000075"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">Take Action</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onCloseResolve()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="resolveForm" (ngSubmit)="onSubmitResolve()">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="role_name">Action</label>
                <!-- <select2
                  [data]="resolveAction"
                  (update)="takeAction($event)"
                  formControlName="is_approved"
                  placeholder="Select Action"
                ></select2> -->
                <select
                  class="form-control"
                  formControlName="is_approved"
                  (change)="takeAction($event)"
                >
                  <option
                    *ngFor="let data of resolveAction"
                    [value]="data.value"
                  >
                    {{ data.label }}
                  </option>
                </select>
                <div
                  *ngIf="submit && resolveErrorMsg.is_approved.errors"
                  class="form-error"
                >
                  <div *ngIf="resolveErrorMsg.is_approved.errors.required">
                    Action is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="cmmntsaward">Comments</label>
                <textarea
                  type="text"
                  formControlName="remark"
                  class="form-control"
                  placeholder="Comments"
                ></textarea>
                <div
                  *ngIf="submit && resolveErrorMsg.remark.errors"
                  class="form-error"
                >
                  <div *ngIf="resolveErrorMsg.remark.errors.required">
                    Comments is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary btn-sm">
            {{ btnName }}
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            (click)="onCloseResolve()"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  id="regularise_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 1060 !important"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title">Attendance regularisation</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="regulariseFrom" (ngSubmit)="onSubmitRegulariseFrom()">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="cmmntsaward">Remark</label>
                <textarea
                  type="text"
                  formControlName="remark"
                  class="form-control"
                  placeholder="Comments"
                ></textarea>
                <div
                  *ngIf="submit && regulariseErrorMsg.remark.errors"
                  class="form-error"
                >
                  <div *ngIf="regulariseErrorMsg.remark.errors.required">
                    Remark is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary btn-sm">Submit</button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- last working  date update -->
<div
  id="exit_date_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          Extend Last Working Day Date
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeExitDateModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="extendExit" (ngSubmit)="onSubmitExitDate()">
        <div class="modal-body text-left">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="form-group">
                <label for=""
                  >Select Date<span class="text-danger">*</span></label
                >
                <input
                  type="date"
                  [min]="minDate"
                  class="form-control"
                  formControlName="ext_date"
                />
                <div
                  *ngIf="updateExitDate && exitDateErrorMsg.ext_date.errors"
                  class="form-error"
                >
                  <div *ngIf="exitDateErrorMsg.ext_date.errors.required">
                    Extend Date is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary btn-sm">SAVE</button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            (click)="closeExitDateModal()"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Exit Update modal -->
<div
  id="exit_update_modal"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 1060 !important"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          Update Exit Reason
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeExitUpdateModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="exitUpdateForm" (ngSubmit)="onUpdateExit()">
        <div class="modal-body text-left">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Resignation Type</label>
                <select
                  class="form-control"
                  (change)="changeExitType($event)"
                  formControlName="vltry_id"
                >
                  <option value="">Select</option>
                  <option
                    *ngFor="let data of voltryList"
                    value="{{ data.value }}"
                  >
                    {{ data.label }}
                  </option>
                </select>
                <div
                  *ngIf="updateExit && exitUpdateErrorMsg.vltry_id.errors"
                  class="form-error"
                >
                  <div *ngIf="exitUpdateErrorMsg.vltry_id.errors.required">
                    Resignation Type is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Reason for Leaving</label>
                <select class="form-control" formControlName="rsn_id">
                  <option value="">Select</option>
                  <option
                    *ngFor="let data of reasonList"
                    value="{{ data.value }}"
                  >
                    {{ data.label }}
                  </option>
                </select>
                <div
                  *ngIf="updateExit && exitUpdateErrorMsg.rsn_id.errors"
                  class="form-error"
                >
                  <div *ngIf="exitUpdateErrorMsg.rsn_id.errors.required">
                    Reason is required !
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="row">
                <div class="col-10 padding-right-2">
                  <div class="form-group">
                    <label
                      >New Reporting Manager<span class="text-danger"></span
                    ></label>
                    <input
                      type="text"
                      placeholder="Search User"
                      formControlName="rpls_rm_username"
                      class="form-control"
                      (input)="onInput($event)"
                    />
                  </div>
                </div>
                <div class="col-2 col-pn">
                  <button
                    type="button"
                    class="btn btn-warning btn-sm m-t-26"
                    (click)="searchEmp()"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary btn-sm">Submit</button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            (click)="closeExitUpdateModal()"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- exit Rejection remark modal -->
<div
  id="exit_reject_remark"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
  style="z-index: 1060 !important"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content" style="box-shadow: 2px 2px 5px black">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          Approver Remark
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeExitReson()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="exitRejectForm" (ngSubmit)="onSubmitExitRejection()">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Remark</label>
                <textarea
                  type="text"
                  formControlName="approver_remark"
                  class="form-control"
                  placeholder="Comments.."
                ></textarea>
                <div
                  *ngIf="
                    exitReject && exitRemarkErrorMsg.approver_remark.errors
                  "
                  class="form-error"
                >
                  <div
                    *ngIf="exitRemarkErrorMsg.approver_remark.errors.required"
                  >
                    Comments is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary btn-sm">Reject</button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            (click)="closeExitReson()"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
